import { render, staticRenderFns } from "./HistoryFull.vue?vue&type=template&id=4dd227de&scoped=true"
import script from "./HistoryFull.vue?vue&type=script&lang=js"
export * from "./HistoryFull.vue?vue&type=script&lang=js"
import style0 from "./HistoryFull.vue?vue&type=style&index=0&id=4dd227de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd227de",
  null
  
)

export default component.exports